import { Typography, SystemIcon, Divider } from '@wishket/design-system';
import { Sheet } from 'react-modal-sheet';

import { HighlightShareBottomSheetProps } from './ShareBox.types';

import {
  openFacebookSharePopup,
  openLinkedInSharePopup,
  openTwitterSharePopup,
} from '@/shared/utils';

const HighlightShareBottomSheet = ({
  url,
  title,
  isShareSheetOpen,
  closeShareSheet,
}: HighlightShareBottomSheetProps) => {
  const linkParams = { url, title };
  return (
    <Sheet
      isOpen={isShareSheetOpen}
      onClose={closeShareSheet}
      data-testid="bottom-sheet-removable-list"
      detent="content-height"
    >
      <Sheet.Container className="react-modal-sheet-container">
        <Sheet.Header />
        <Sheet.Content className="px-5 pb-6 pt-1">
          <button
            className="flex items-center gap-3 p-4"
            onClick={() => openTwitterSharePopup(linkParams)}
          >
            <SystemIcon name="social_x" />
            <Typography variant="body1">트위터</Typography>
          </button>
          <Divider />
          <button
            className="flex items-center gap-3 p-4"
            onClick={() => openFacebookSharePopup(linkParams)}
          >
            <SystemIcon name="social_facebook" />
            <Typography variant="body1">페이스북</Typography>
          </button>
          <Divider />
          <button
            className="flex items-center gap-3 p-4"
            onClick={() => openLinkedInSharePopup(linkParams)}
          >
            <SystemIcon name="social_linked_in" />
            <Typography variant="body1">링크드인</Typography>
          </button>
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop onTap={closeShareSheet} />
    </Sheet>
  );
};

export default HighlightShareBottomSheet;
